import React from 'react'
import ServiceBanner from '../../Components/Services/ServiceBanner'
import "./service.css"
import ManagementSystemCert from '../../Components/Services/ManagementSystemCert'
import ManagementSystemTraining from '../../Components/Services/ManagementSystemTraining'
import ThirdPartySystem from '../../Components/Services/ThirdPartySystem'
import ScheduleConsultaion from '../../Components/Services/ScheduleConsultaion'
import HomeServices from '../../Components/Home/HomeServices'

const ServicePage = () => {
  return (
    <div>
      <ServiceBanner/>
      <ManagementSystemCert/>
      <ManagementSystemTraining/>
      <ThirdPartySystem/>
      <ScheduleConsultaion/>
      <HomeServices/>
    </div>
  )
}

export default ServicePage
